import React from 'react';
import './VisualGrid.scss';
import { useDashboardDomainContext } from "../../DashboardDomainProvider";
import { useFullscreen } from '../../contexts/FullScreenContext';
import VisualCreationDialog from '../dialogs/VisualCreationDialog';
import { UnpublishedMessage, WelcomeMessage, NoVisualsMessage, NoPagesMessage } from './messages';
import { VisualGridBody } from './subcomponents/VisualGridBody';
import FullscreenOverlay from './subcomponents/FullscreenOverlay';

export const VisualGrid = () => {
  const {
    activeDashboard,
    selectedPageData,
    hasPages,
    isViewMode,
    isDashboardPublished,
    isCurrentPageEmpty,
    isOwner,
  } = useDashboardDomainContext();
  const { fullscreenCard } = useFullscreen();

  const isBlockedByUnpublishedView = activeDashboard && hasPages && isViewMode && !isDashboardPublished && isOwner;
  const shouldShowGrid =
    !!activeDashboard &&
    hasPages &&
    !!selectedPageData &&
    !isBlockedByUnpublishedView &&
    (!isViewMode || !isCurrentPageEmpty);

  return (
    <div className='visual-grid-container'>
      {!activeDashboard && <WelcomeMessage />}
      {activeDashboard && !hasPages && <NoPagesMessage />}
      {isBlockedByUnpublishedView && <UnpublishedMessage />}
      {activeDashboard && hasPages && selectedPageData && isViewMode && isCurrentPageEmpty && !isBlockedByUnpublishedView && <NoVisualsMessage />}
      {shouldShowGrid && <VisualGridBody />}
      <VisualCreationDialog />
      {fullscreenCard && <FullscreenOverlay card={fullscreenCard} />}
    </div>
  );
};
